<ng-container *transloco="let t">
  <!-- Use flex with column direction and set a fixed height -->
  <div class="flex flex-col h-full max-h-[80vh]">
    <!-- Content section - scrollable -->
    <div class="flex-1 overflow-y-auto">
      <p-fluid>
        <form [formGroup]="form">
          <formly-form [form]="form" [model]="model" [fields]="fields"></formly-form>
        </form>
      </p-fluid>
    </div>

    <!-- Footer section - fixed -->
    <div class="mt-3 pt-3 border-t border-surface-200 dark:border-surface-700">
      <div class="flex flex-row justify-end flex-wrap gap-3 w-full">
        <p-button [label]="t('app.common.cancel')" severity="secondary" (click)="close()" />
        <p-button
          [label]="definition.submitLabel"
          (click)="submit()"
          [disabled]="form.invalid || (definition.disableSubmitWhenPristine && form.pristine)"
        />
      </div>
    </div>
  </div>
</ng-container>
